var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M60 0L73.6967 8.88321L90 8.03848L97.4201 22.5799L111.962 30L111.117 46.3033L120 60L111.117 73.6967L111.962 90L97.4201 97.4201L90 111.962L73.6967 111.117L60 120L46.3033 111.117L30 111.962L22.5799 97.4201L8.03848 90L8.88321 73.6967L0 60L8.88321 46.3033L8.03848 30L22.5799 22.5799L30 8.03848L46.3033 8.88321L60 0Z",
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5333 65.8L69.2667 50.0667C69.7556 49.5778 70.3778 49.3334 71.1333 49.3334C71.8889 49.3334 72.5111 49.5778 73 50.0667C73.4889 50.5556 73.7333 51.1778 73.7333 51.9334C73.7333 52.6889 73.4889 53.3112 73 53.8L55.4 71.4C54.8667 71.9334 54.2444 72.2 53.5333 72.2C52.8222 72.2 52.2 71.9334 51.6667 71.4L44.7333 64.4667C44.2444 63.9778 44 63.3556 44 62.6C44 61.8445 44.2444 61.2223 44.7333 60.7334C45.2222 60.2445 45.8444 60 46.6 60C47.3556 60 47.9778 60.2445 48.4667 60.7334L53.5333 65.8Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.4a544975764b5024f317cde32a59d659.svg";
export { ForwardRef as ReactComponent };